exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/rory/Sites/baxter-outdoors/wp-content/themes/outdoors/node_modules/core-js/modules/_wks-ext.js
// module id = 98
// module chunks = 0